export enum GraphType {
  line = 'line',
  doughnut = 'doughnut'
}
